import React, { useState } from "react";
import PlanSetup from "../../components/commonComponent/DashboardCommonComponent/PlanSetup";
import DashboardDetails from "../../components/commonComponent/DashboardCommonComponent/DashboardDetails";

const KitchenDashboard: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  // handleClick accepts a boolean: true = open dashboard, false = close dashboard.
  const handleClick = (openValue: boolean): void => {
    setOpen(openValue);
  };

  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">Kitchen Dashboard</h1>
      <PlanSetup handleClick={handleClick} />
      {open && <DashboardDetails />}
    </div>
  );
};

export default KitchenDashboard;
